import CloneJobOpening from "./cloneJobOpening";
export default CloneJobOpening;